import React, { Fragment } from 'react';

const Switch = ({name, label, checked, onChange}) => {
return(
  <Fragment>
    <div className="field">
    <input id={name} type="checkbox" name={name} className="switch is-rounded is-info" onChange={onChange} checked={checked}  />
    <label htmlFor={name} >{label}</label>
  </div>
  </Fragment>
)
;}
export default Switch;